import { ShapeProps } from '@features/powerpoint';
import { SalesDimensionsSlideBaseOptions } from './content';
import {
  dimensionBlueRectangle,
  dimensionLine,
  dimensionNameRectangle,
  overallPerformanceRectangle,
} from '../../dimensions/shapes';
import {
  applyDimensionXOffset,
  applyDimensionYOffset,
} from '@features/executive-report/dimensions/layout';

export const rectangleOptions = {
  h: 1.09,
  w: 2.28,
  x: 4.35,
  y: 3.33,
} as const satisfies ShapeProps['options'];

export const shapes = (
  subdimensions: SalesDimensionsSlideBaseOptions['subdimensions']
): ShapeProps[] => [
  overallPerformanceRectangle,
  dimensionBlueRectangle,
  ...subdimensions.flatMap((subdimension, index): ShapeProps[] => [
    ...(subdimension.image
      ? []
      : [
          dimensionNameRectangle({
            ...rectangleOptions,
            x: rectangleOptions.x + applyDimensionXOffset(index),
            y: rectangleOptions.y + applyDimensionYOffset(index),
          }),
        ]),
    dimensionLine({
      x: 4.35 + applyDimensionXOffset(index),
      y: 5.16 + applyDimensionYOffset(index),
    }),
  ]),
];
